
// Backend timestamps are UTC but may arrive without a timezone designator
// (e.g. "2026-08-27T10:00:00"). Append "Z" so they're parsed as UTC — but only
// when the value has a time component and no timezone yet, so we don't corrupt
// values that already carry "Z" / an explicit offset ("+00:00"), or date-only
// strings (which JS already parses as UTC midnight).
export const parseUtcDate = (utcTime: string): Date => {
  const hasTimezone = /[zZ]$/.test(utcTime) || /[+-]\d{2}:?\d{2}$/.test(utcTime);
  const hasTime = /\d{2}:\d{2}/.test(utcTime);
  return new Date(hasTime && !hasTimezone ? utcTime + "Z" : utcTime);
};

export const currentLocale = (): string | undefined =>
  typeof navigator !== "undefined" ? navigator.language : undefined;

export const parseDateAndTimeByLocale = (utcTime: string | null): string => {
  if (!utcTime) return "";

  return parseUtcDate(utcTime).toLocaleString(currentLocale(), {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};